import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { GameTypeValue } from '@/shared/config/constants';

import { LeaderboardEntry, LeaderboardPeriod, LeaderboardSortBy, MyRankResponse } from './types';

export interface LeaderboardState {
  entries: LeaderboardEntry[];
  offset: number;
  hasMore: boolean;
  loading: boolean;
  initialLoading: boolean;
  period: LeaderboardPeriod;
  sortBy: LeaderboardSortBy;
  gameType: GameTypeValue;
  myRank: MyRankResponse | null;
}

const initialState: LeaderboardState = {
  entries: [],
  offset: 0,
  hasMore: false,
  loading: false,
  initialLoading: true,
  period: 'all_time',
  sortBy: 'profit',
  gameType: 'global',
  myRank: null,
};

const leaderboardSlice = createSlice({
  name: 'leaderboard',
  initialState,
  reducers: {
    setPeriod(state, action: PayloadAction<LeaderboardPeriod>) {
      state.period = action.payload;
    },

    setSortBy(state, action: PayloadAction<LeaderboardSortBy>) {
      state.sortBy = action.payload;
    },

    setGameType(state, action: PayloadAction<GameTypeValue>) {
      state.gameType = action.payload;
    },

    resetEntries(state) {
      state.entries = [];
      state.offset = 0;
      state.hasMore = false;
      state.initialLoading = true;
      state.myRank = null;
    },

    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    fetchSuccess(
      state,
      action: PayloadAction<{ entries: LeaderboardEntry[]; hasMore: boolean; replace: boolean }>,
    ) {
      const { entries, hasMore, replace } = action.payload;
      state.entries = replace ? entries : [...state.entries, ...entries];
      state.offset = replace ? entries.length : state.offset + entries.length;
      state.hasMore = hasMore;
      state.loading = false;
      state.initialLoading = false;
    },

    setMyRank(state, action: PayloadAction<MyRankResponse | null>) {
      state.myRank = action.payload;
    },

    // Saga triggers — no reducer logic
    fetchPage(_state, _action: PayloadAction<boolean>) {},
    fetchNextPage() {},
  },
});

export const leaderboardActions = leaderboardSlice.actions;
export const leaderboardReducer = leaderboardSlice.reducer;
